<template>
  <div>
    <div class="p-relative header-image pb-5"></div>

    <b-container class="custom-container mt-5">
      <b-row>
        <b-col cols="12" class="px-3">
          <candidates-tabs />

          <h4 class="font-weight-bold pt-4 pb-1 align-middle">Talent Pools</h4>
          <p class="text-muted mb-4">
            Group saved candidates into named pools, with tags and notes for
            your own recruitment tracking.
          </p>

          <pool-management-list @error="onError" />
        </b-col>
      </b-row>
    </b-container>

    <b-alert
      class="custom-alert"
      :show="dismissCountDown"
      variant="danger"
      dismissible
      fade
      @dismiss-count-down="(val) => (dismissCountDown = val)"
    >
      {{ alertMsg }}
    </b-alert>
  </div>
</template>

<script>
import CandidatesTabs from '@/components/candidates/CandidatesTabs.vue'
import PoolManagementList from '@/components/candidates/PoolManagementList.vue'

export default {
  name: 'CandidatesPoolsPage',

  components: {
    CandidatesTabs,
    PoolManagementList,
  },

  data() {
    return {
      dismissCountDown: 0,
      alertMsg: '',
    }
  },

  methods: {
    onError(err) {
      this.alertMsg =
        (err && err.data && err.data.message) ||
        (err && err.message) ||
        'Something went wrong.'
      this.dismissCountDown = 5
    },
  },
}
</script>
